module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-results-filters-collapse-box collapse in"
  }, [_c('div', {
    staticClass: "ibox-results-filters"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.$user.isAdminOrCoordinator) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Select User")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "options": _vm.initialUserOptions,
      "fetch-results": _vm.fetchUserResults,
      "name": "user_id"
    },
    model: {
      value: (_vm.user_id),
      callback: function($$v) {
        _vm.user_id = $$v
      },
      expression: "user_id"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Keyword")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Location Name or Address"
    },
    on: {
      "input": _vm.updateKeywords
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Contact Name/Phone")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "..."
    },
    on: {
      "input": _vm.updateContactName
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("State")]), _vm._v(" "), _c('selectize', {
    staticClass: "form-control select2-material-placeholder",
    attrs: {
      "name": "state",
      "options": _vm.stateOptions
    },
    model: {
      value: (_vm.state),
      callback: function($$v) {
        _vm.state = $$v
      },
      expression: "state"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-locations"
  }, _vm._l((_vm.locations), function(location) {
    return _c('li', [_c('div', {
      staticClass: "location-favourite",
      class: {
        'favourite': location.favourite
      }
    }, [_c('i', {
      staticClass: "fa fa-star",
      on: {
        "click": function($event) {
          _vm.handleFavouriteLocation(location.id)
        }
      }
    })]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'locations.edit',
          params: {
            id: location.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setActiveLocation(location)
        }
      }
    }, [_c('h2', {
      staticClass: "truncate"
    }, [_c('strong', [_vm._v(_vm._s(location.name) + " ")]), _vm._v(" "), (location.suburb) ? [_vm._v("\n                  - " + _vm._s(location.suburb) + "\n                ")] : _vm._e()], 2), _vm._v(" "), (location.address) ? _c('p', {
      staticClass: "truncate"
    }, [_vm._v("\n                " + _vm._s(location.address) + "\n              ")]) : _c('p', {
      staticClass: "truncate"
    }, [_vm._v("\n                 \n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "map-thumb hidden-xs"
    }, [_c('img', {
      attrs: {
        "src": require("assets/img/map-thumb-512.png")
      },
      on: {
        "click": function($event) {
          _vm.openLocationMapModal(location)
        }
      }
    })])], 1)
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveNoLocations),
      expression: "haveNoLocations"
    }],
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("There are no locations.")])])]), _vm._v(" "), _c('lazy-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveLocations),
      expression: "haveLocations"
    }],
    ref: "lazyLoading",
    attrs: {
      "reached-bottom": _vm.getLocationsForNextPage,
      "filters": _vm.filters
    }
  }, [_c('strong', {
    staticClass: "text-muted",
    slot: "finished"
  }, [_vm._v("There are no more locations.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade modal-location-map",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [(_vm.showingLocationMapModal) ? _c('div', {
    staticClass: "modal-dialog modal-lg",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n            " + _vm._s(_vm.selectedMapLocation.name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.selectedMapLocation.latitude && _vm.selectedMapLocation.longitude) ? _c('gmap-map', {
    ref: "map",
    staticStyle: {
      "width": "100%",
      "height": "600px"
    },
    attrs: {
      "center": {
        lat: _vm.selectedMapLocation.latitude,
        lng: _vm.selectedMapLocation.longitude
      },
      "zoom": 8
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": {
        lat: _vm.selectedMapLocation.latitude,
        lng: _vm.selectedMapLocation.longitude
      }
    }
  })], 1) : _c('p', {
    staticClass: "m-t-lg lead text-center"
  }, [_vm._v("\n              There is no map location set.\n            ")])], 1), _vm._v(" "), _vm._m(1)])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ibox-results-collapse visible-xs",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "href": ".ibox-results-filters-collapse-box",
      "aria-expanded": "false",
      "aria-controls": "ibox-results-filters-collapse-box"
    }
  }, [_vm._v("\n\t\t\t\tShow Filters "), _c('i', {
    staticClass: "fa fa-bars"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 footer-left"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-5eaa521b"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/locations/Locations.vue
// module id = 1016
// module chunks = 0